import React from 'react';
import classNames from 'classnames';

const ns = `plain-button`;

const PlainButton = ({children, className, ...rest}) => {
	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[`${ className }`]: className,
	});

	return (
		// eslint-disable-next-line react/jsx-props-no-spreading
		<button className={rootClassnames} {...rest}>
			{children}
		</button>
	);
};

export default PlainButton;
